import { Directive, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
export class CollapseDirective {
    constructor() {
        this.collapse = new EventEmitter();
        this.expand = new EventEmitter();
    }
    set mheCollapse(value) {
        if (value === true || value === undefined) {
            this.collapseContainer();
        }
        else {
            this.expandContainer();
        }
    }
    collapseContainer() {
        this.display = 'none';
        this.collapse.emit(this);
    }
    expandContainer() {
        this.display = 'block';
        this.expand.emit(this);
    }
}
CollapseDirective.ɵfac = function CollapseDirective_Factory(t) { return new (t || CollapseDirective)(); };
CollapseDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: CollapseDirective, selectors: [["", "mheCollapse", ""]], hostVars: 2, hostBindings: function CollapseDirective_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵstyleProp("display", ctx.display);
    } }, inputs: { mheCollapse: "mheCollapse" }, outputs: { collapse: "collapse", expand: "expand" }, exportAs: ["mhe-collapse"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapseDirective, [{
        type: Directive,
        args: [{
                selector: '[mheCollapse]',
                exportAs: 'mhe-collapse',
            }]
    }], null, { display: [{
            type: HostBinding,
            args: ['style.display']
        }], mheCollapse: [{
            type: Input
        }], collapse: [{
            type: Output
        }], expand: [{
            type: Output
        }] }); })();
